import {
  TEAM_USERS_FILTER_ALL,
  TEAM_USERS_FILTER
} from 'admin/Teams/constants'
import { SET_SYSTEM_THEME_MODE, resolveSystemMode } from 'modules/systemTheme'

const teamInitialState = {
  usersFilter: TEAM_USERS_FILTER_ALL
}

const team = (state = teamInitialState, { payload, type }) => {
  switch (type) {
    case TEAM_USERS_FILTER:
      return {
        usersFilter: payload.filter
      }
    default:
      return state
  }
}

// Live OS theme preference. Kept in sync by a single matchMedia listener (see
// modern.js) so 'system' theme changes propagate app-wide like a manual toggle.
const themeInitialState = { systemMode: resolveSystemMode() }

const theme = (state = themeInitialState, { payload, type }) => {
  switch (type) {
    case SET_SYSTEM_THEME_MODE:
      return { systemMode: payload }
    default:
      return state
  }
}

export default (state = {}, action) => {
  return {
    team: team(state.team, action),
    theme: theme(state.theme, action)
  }
}
